import DesktopNavigation from "./Desktop";
import MobileNavigation from "./Mobile";

const RenderMenu = ({
  menuItems,
  mobileMenuShortcuts,
  mobileMenuId,
  is404,
}: {
  menuItems: any;
  mobileMenuShortcuts?: any;
  mobileMenuId?: string;
  is404: boolean;
}) => {
  return (
    <>
      <DesktopNavigation menuItems={menuItems} />

      <MobileNavigation
        menuItems={menuItems}
        mobileMenuShortcuts={mobileMenuShortcuts}
        mobileMenuId={mobileMenuId}
        is404={is404}
      />
    </>
  );
};

export default RenderMenu;
